import { render, staticRenderFns } from "./PageSkeleton.vue?vue&type=template&id=58461398&scoped=true"
var script = {}
import style0 from "./PageSkeleton.vue?vue&type=style&index=0&id=58461398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58461398",
  null
  
)

export default component.exports